module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-17.7c3b3380.png";